// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"7f93e1a3","292":"8ef29f71","498":"796d4985","522":"4ddce719","551":"465d4766","828":"ea744a78"}[chunkId] + ".chunk.js";
};